export default __webpack_public_path__ + "static/media/37-min.a515b8f7.jpg";